/**
 * Utility functions for admin mode management
 */

// Use sessionStorage instead of localStorage to reset on page reload
export function getAdminMode(): 'test' | 'live' {
  const savedMode = sessionStorage.getItem('admin_mode_override');
  return savedMode === 'test' ? 'test' : 'live'; // Default to live mode
}

export function getAdminModeHeaders(): Record<string, string> {
  const mode = getAdminMode();
  return mode === 'test' ? { 'x-admin-mode': 'test' } : {};
}

export function isLiveMode(): boolean {
  return getAdminMode() === 'live';
}

export function getStripePublishableKey(): string {
  const mode = getAdminMode();
  
  if (mode === 'live') {
    const liveKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_LIVE;
    if (!liveKey) {
      console.warn('Live Stripe publishable key not configured, falling back to test key');
      return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
    }
    return liveKey;
  } else {
    return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
  }
} 